<template>
    <div class="direction">
        <header>Dialogbuch &ndash; Schwerpunkt Anime</header>

        <div class="navigation navigation-left" @click="navLeft()"><span class="mdi mdi-arrow-left"></span></div>

        <div class="work-roles-list">
            <WorkRoleItem v-for="workRole in directionRoles" v-bind="workRole" v-bind:key="workRole.id" v-bind:isActive="workRole.role_type == 'dialogbuch'" />
        </div>

        <div class="navigation navigation-right" @click="navRight()"><span class="mdi mdi-arrow-right"></span></div>

        <div class="textbox" v-html="directionText">
        </div>
    </div>
</template>

<script>
    import WorkRoleItem from '@/components/WorkRoles/WorkRoleItem.vue';

    export default {
        name: 'Direction',
        data: function() {
            return {
                directionRoles: [],
                allDirectionRoles: [],
                directionText: "",
            }
        },
        components: {
            WorkRoleItem,
        },
        mounted: function() {
            this.$root.$on('workRoles-changed', (workRoles) => {
                workRoles.forEach(item => {
                    if(item.role_type === 'dialogbuch') {
                        this.allDirectionRoles.push(item);
                        this.loadRoles();
                    }
                });
            });
            this.$root.$on('texts-changed', (texts) => {
                this.$data.directionText = texts[0].dialogbuch;
            });
        },
        methods: {
            navLeft: function() {
                this.$data.allDirectionRoles.unshift(this.$data.allDirectionRoles.pop());
                this.loadRoles();
            },
            navRight: function() {
                this.$data.allDirectionRoles.push(this.$data.allDirectionRoles.shift());
                this.loadRoles();
            },
            loadRoles: function() {
                this.$data.directionRoles = this.$data.allDirectionRoles;
            },
        }
    };
</script>

<style scoped lang="less">
    .direction {
        display: grid;
        grid-template-rows: auto auto auto;
        grid-template-columns: 50px 1fr 50px;
        grid-gap: 15px;
        padding: 50px 0px;
        padding-top: 25px;
        max-width: 1200px;
        margin: 0 auto;

        & header {
            grid-column: 1 / span 3;
            text-align: center;
            font-weight: bold;
            font-size: 32px;
            margin-bottom: 15px;
        }
        & .navigation {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
            box-shadow: 0px 2px 15px rgba(0,0,0,0.3);
            transition: 0.2s ease-in-out all;
            width: 50px;
            height: 50px;
            align-self: center;
            justify-self: center;
            border-radius: 100px;
            font-size: 22px;

            &:hover {
                background: #fff;
                box-shadow: 0px 2px 25px rgba(0,0,0,0.45);
                cursor: pointer;
            }
        }
        & .work-roles-selection {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            max-width: 900px;
            margin: 0 auto;

            & .selection-item {
                padding: 5px 25px;
                border-radius: 100px;
                text-transform: uppercase;
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 0.1em;
                margin-right: 15px;
                margin-bottom: 10px;
                transition: 0.15s ease-in-out all;
                display: flex;
                align-items: center;

                & .mdi {
                    font-size: 22px;
                    margin-right: 5px;
                }

                &.active {
                    background: rgba(0,0,0,0.17);
                }
                &:hover {
                    background: rgba(0,0,0,0.07);
                    cursor: pointer;
                }
            }
        }
        & .work-roles-list {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
            grid-gap: 10px;
            grid-template-rows: auto;
            grid-auto-rows: 0px;
            overflow: hidden;
        }
        & .textbox {
            grid-column: 1 / span 3;
            margin-top: 25px;
            padding: 25px 40px;
            background: #fff;
            border-radius: 6px;
            box-shadow: 0px 2px 20px rgba(0,0,0,0.15);
            line-height: 1.5em;
            display: grid;
            grid-gap: 15px;
        }
    }

    @media screen and (max-width: 1250px) {
        .direction {
            width: 95vw;

            & .work-roles-selection {
                flex-wrap: wrap;
                align-items: center;
            }

            & .work-roles-list {
                grid-template-columns: 1fr 1fr;
            }
        }
    }

    @media screen and (max-width: 700px) {
        .direction {
            & .work-roles-list {
                grid-template-columns: 1fr;
            }
        }
    }
</style>
